import bodyService from '../services/body';
import DomComponent from '../lib/domComponent';
import { each, mq, isMobileSafari } from '../lib/util';
import SearchComponent from '../components/search/search';
import ColorBars from '../services/color-bars';

export default class HeaderComponent extends DomComponent {
    static selector = '[data-js-header]';
    el;

    lastScroll = 0;
    logoRotationSpeed = 0.2;
    active = null;
    activeSubmenu;
    menuMap = {};
    toggles;
    menus;

    desktopMediaQuery = '1280px';
    desktopHeight = 90;
    toggleActiveClass = 'header__button--active';
    menuCtrActiveClass = 'header__menu-container--open';
    menuActiveClass = 'header__menu--active';

    submenuNameSelector = '[data-name-placeholder]';
    submenuImageSelector = '[data-submenu-image]';
    submenuNavSelector = '[data-submenu-nav]';
    submenuNavItemSelector = '[data-submenu-nav-item]';
    submenuDefaults = {};
    isTouchDevice = 'ontouchstart' in window;

    constructor(el) {
        // return false
        super(el);

        // query dom for elements
        this.menuToggles = this.el.querySelectorAll('[data-toggle]');
        this.subMenuToggles = this.el.querySelectorAll('[data-toggle-submenu]');
        this.subMenuBackButtons = this.el.querySelectorAll('[data-close-submenu]');
        this.subMenuContainer = this.el.querySelector('[data-submenu-container]');
        this.subMenus = this.el.querySelectorAll('[data-submenu]');
        this.mainSubMenus = this.el.querySelectorAll('[data-submenu]');
        this.menuContainer = this.el.querySelector('[data-menu-container]');
        this.menus = this.el.querySelectorAll('[data-menu]');
        this.logoCircle = this.el.querySelector('[data-logo-circle]');
        this.headerMenuNav = this.el.querySelector('.header__menu__nav');
        this.layout = document.querySelector('.layout');
        this.morebutton = this.el.querySelector('.header__menu__more-button');
        this.headerInner = this.el.querySelector('.header__inner');
        this.chatButton = document.querySelector('#divSatisfiChat');
        this.$emergencyBanner = document.querySelector('[data-js-emergency-alert]');

        if (this.headerMenuNav) {
            this.subMenuButtons = this.headerMenuNav.querySelectorAll('.header__menu__nav__button');
        }

        //mobile Safari isn't very friendly. Depending on your scroll, panels on the top and bottom collapse in
        //we need to adjust the UI for these panels as sometimes they will hide the "More" button in the submenu
        // if(this.isTouchDevice && isMobileSafari() && !mq(this.desktopMediaQuery)){
        //     this.checkMobileHeight();
        //     window.addEventListener('resize', this.checkMobileHeight.bind(this));
        // }

        // construct map of menus
        for (let i = 0; i < this.menus.length; i++) {
            this.menuMap[this.menus[i].dataset.menu] = this.menus[i];
        }

        //set initial state of submenus
        if (mq(this.desktopMediaQuery)) {
            if (this.subMenuContainer) {
                this.subMenuContainer.style.height = '0';
            }
        }

        //scroll event handler
        this.initScrollHandlers();

        // desktop submenu hover events
        each(this.subMenus, (subMenu) => {
            if(subMenu.dataset.submenu === 'more') {
                return;
            }

            const image = subMenu.querySelector(this.submenuImageSelector);
            const namePlaceholder = subMenu.querySelector(this.submenuNameSelector);
            const nav = subMenu.querySelector(this.submenuNavSelector);

            if (nav && image && namePlaceholder) {
                //add swap image/text hover functionality

                const imageIncoming = image.cloneNode();
                const nameIn = namePlaceholder.nextElementSibling;
                const nameOut = nameIn.nextElementSibling;
                imageIncoming.classList.add('incoming');
                image.parentElement.insertBefore(imageIncoming, image.nextSibling);
                this.adjustFontSize(namePlaceholder, namePlaceholder.innerText);

                let animating = 0;
                let activeText;
                let activeImage;

                setTimeout(() => {
                    namePlaceholder.parentElement.style.width = `${namePlaceholder.offsetWidth}px`;
                }, 450);
                this.submenuDefaults[subMenu.dataset.submenu] = {
                    name: namePlaceholder.innerText,
                    image: image.getAttribute('src')
                };

                nav.addEventListener('mouseleave', (event) => {
                    if(mq(this.desktopMediaQuery)) {
                        if(animating !== 0) {
                            this.endSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, imageIncoming, image);
                            animating = 1;
                        }

                        activeText = this.submenuDefaults[subMenu.dataset.submenu].name;
                        activeImage = this.submenuDefaults[subMenu.dataset.submenu].image;

                        this.startSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, namePlaceholder, imageIncoming, image);


                        setTimeout(() => {
                            this.endSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, imageIncoming, image);
                        }, 300)
                    }
                });

                nav.addEventListener('mouseover', (event) => {
                    if(mq(this.desktopMediaQuery)) {
                        animating++;

                        if(animating > 1) {
                            this.endSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, imageIncoming, image);
                        }

                        if(event.target && typeof event.target.dataset.submenuNavItem !== 'undefined') {

                            activeText = event.target.innerText.toLowerCase();
                            activeImage = event.target.dataset.submenuNavItem;

                            this.startSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, namePlaceholder, imageIncoming, image);

                            setTimeout(() => {;
                                animating--;
                                if(animating === 0) {
                                    this.endSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, imageIncoming, image);
                                }
                            }, 300)

                        }
                        // else{
                        //     activeText = this.submenuDefaults[subMenu.dataset.submenu].name;
                        //     activeImage = this.submenuDefaults[subMenu.dataset.submenu].image;
                        // }


                    }
                })
            }
        })

        // mobile menu toggle click events
        each(this.menuToggles, (toggle, i) => {
            toggle.addEventListener('click', () => {
                if (mq(this.desktopMediaQuery)) {
                    return;
                }

                var hasChatButton = this.checkForChatButton();
                var hasEmergencyBanner = this.$emergencyBanner && document.body.classList.contains('emergency-alert-visible--banner');

                // Close Menu
                if (toggle.classList.contains(this.toggleActiveClass)) {
                    const chatWidget = document.querySelector('#divSatisfiChat');
                    if (chatWidget) {
                        chatWidget.style.display = 'block';
                    }
                    this.el.classList.remove('open');
                    this.active.menu.classList.remove(this.menuActiveClass);
                    this.active.toggle.classList.remove(this.toggleActiveClass);
                    this.active = null;
                    this.menuContainer.classList.remove(this.menuCtrActiveClass);
                    each(this.subMenus, (submenu) => {
                        submenu.classList.remove('active');
                        this.headerMenuNav.style.height = '';
                    });
                    this.menuMap[toggle.dataset.toggle].classList.remove('open');

                    bodyService.unlock();
                    if (this.isTouchDevice) {
                         this.layout.classList.remove('mobile-lock');
                    }

                    // if there is a chat button, show it
                    if (hasChatButton) {
                        this.chatButton.style.display = '';
                    }

                    // if there is an emergency banner, show it
                    if (hasEmergencyBanner) {
                        this.expandAlert();
                    }
                }
                // Open Menu
                else {
                    const chatWidget = document.querySelector('#divSatisfiChat');
                    if (chatWidget) {
                        chatWidget.style.display = 'none';
                    }
                    bodyService.lock();
                    if(this.isTouchDevice){
                        this.layout.classList.add('mobile-lock');
                        // this.checkMobileHeight();
                    }

                    if(!this.menuMap[toggle.dataset.toggle].classList.contains('open')) {
                        setTimeout(() => {
                            this.menuMap[toggle.dataset.toggle].classList.add('open');
                        }, 300);
                    }

                    // if menus already open, hide any menu content inside
                    if(this.active) {
                        this.active.menu.classList.remove(this.menuActiveClass);
                        this.active.toggle.classList.remove(this.toggleActiveClass);
                        each(this.subMenus, (submenu) => {
                            submenu.classList.remove('active');
                            this.headerMenuNav.style.height = '';
                        });
                    }else{
                        // otherwise, open menu
                        this.menuContainer.classList.add(this.menuCtrActiveClass);
                    }

                    // set new active menu
                    this.active = {
                        toggle: toggle,
                        menu: this.menuMap[toggle.dataset.toggle],
                    }

                    // show active menu
                    this.active.menu.classList.add(this.menuActiveClass);
                    this.active.toggle.classList.add(this.toggleActiveClass);

                    // if there is a chat button, hide it
                    if (hasChatButton) {
                        this.chatButton.style.display = 'none';
                    }

                    // if there is an emergency banner, hide it
                    if (hasEmergencyBanner) {
                        this.collapseAlert();
                    }
                }
            })
        })

        // back button click events
        each(this.subMenuBackButtons, (button) => {
            button.addEventListener('click', () => {
                each(this.subMenus, (submenu) => {
                    submenu.classList.remove('active');
                    this.headerMenuNav.style.height = '';
                })
            });
        })

        each(this.subMenuToggles, (toggle, index) => {
            const toggleSubmenu = toggle.dataset.toggleSubmenu;
            toggle.addEventListener('mouseenter', (e) => {
                if (toggleSubmenu === 'more' || toggleSubmenu === 'search') {
                    return;
                }
                // desktop main hover events
                if(mq(this.desktopMediaQuery)) {
                    each(this.subMenus, (subMenu) => {
                        if (subMenu.dataset.submenu === toggle.dataset.toggleSubmenu) {
                            if (this.activeSubmenu === subMenu.dataset.submenu || this.activeSubmenu === 'search') {
                                return;
                            }

                            this.activeSubmenu = subMenu.dataset.submenu;


                            if (!subMenu.classList.contains('active')) {
                                subMenu.classList.add('active');
                            }
                            if (!toggle.classList.contains('active')) {
                                toggle.classList.add('active');
                            }

                            this.updateSubmenuHeight(subMenu);

                            function submenuMouseleaveHandler (e) {

                                const menu = e.toElement ? e.toElement.dataset.toggleSubmenu : null;
                                if(!menu || menu !== subMenu.dataset.submenu) {
                                    closeMenu.call(this);
                                }
                            }

                            function toggleMouseleaveHandler (e) {
                                const toElement = e.toElement || e.relatedTarget;
                                let menu = toElement ? toElement.dataset.submenu : null;
                                menu = menu ? menu : (toElement && toElement.parentElement ? toElement.parentElement.dataset.submenu : null);

                                if (!menu || menu !== subMenu.dataset.submenu) {
                                    closeMenu.call(this);
                                }
                            }

                            function closeMenu() {
                                toggle.classList.remove('active');
                                subMenu.classList.remove('active');
                                if (this.activeSubmenu !== 'search') {
                                    this.subMenuContainer.style.height = 0;
                                    this.activeSubmenu = null;
                                }

                                subMenu.removeEventListener('mouseleave', submenuMouseleaveHandler);
                                toggle.removeEventListener('mouseleave', toggleMouseleaveHandler);
                            }

                           subMenu.addEventListener('mouseleave', submenuMouseleaveHandler.bind(this));
                           toggle.addEventListener('mouseleave', toggleMouseleaveHandler.bind(this));

                        }
                    })

                }
            });

            // Desktop Search Button
            if (toggleSubmenu === 'search') {
                toggle.addEventListener('click', () => {
                    if (mq(this.desktopMediaQuery)) {
                        // Button toggle
                        if (!toggle.classList.contains('active')) {
                            toggle.classList.add('active');
                        } else {
                            toggle.classList.remove('active');
                        }
                        // Submenu
                        each(this.subMenus, (subMenu) => {
                            if (subMenu.dataset.submenu === 'search') {
                                this.activeSubmenu = subMenu.dataset.submenu;
                                this.updateSubmenuHeight(subMenu);
                                if (!subMenu.classList.contains('active')) {
                                    subMenu.classList.add('active');
                                } else {
                                    subMenu.classList.remove('active');
                                    this.subMenuContainer.style.height = 0;
                                    this.activeSubmenu = null;
                                }
                            }
                        });
                    }
                });
            }

            //mobile submenu events
            toggle.addEventListener('click', (e) => {
                // on mobile we have click handlers that handle opening the sub menu
                // we dont need this handler on desktop but we attach it anyway in case
                // the user changes screen size after page load
                if(!mq(this.desktopMediaQuery)) {

                    // prevent navigation on mobile
                    e.preventDefault();

                    each(this.subMenus, (subMenu) => {
                        if (subMenu.dataset.submenu === toggle.dataset.toggleSubmenu) {
                            if (subMenu.classList.contains('active')) {
                                subMenu.classList.remove('active');
                                this.headerMenuNav.style.height = '';
                            } else {
                                subMenu.classList.add('active');
                                this.headerMenuNav.style.height = '90%';
                            }
                        }
                    })
                }

            })
        });

        //set up search functionality
        each(SearchComponent.getEntryElements(), (el) => {
            return new SearchComponent(el, this);
        })


        setTimeout(() => {
            this.loaded();
        })

        setTimeout(() => {
            this.colorBars = new ColorBars(this.subMenuContainer);
        }, 500)
    }

    adjustFontSize(el, text) {
        if (text.length > 25) {
            el.parentElement.classList.add('small');
        }
        else {
            el.parentElement.classList.remove('small');
        }
    }

    // checkMobileHeight(e){
    //     let height = window.innerHeight - this.headerInner.offsetHeight - this.morebutton.offsetHeight;
    //     height = height / 3;
    //     each(this.subMenuButtons, (button) => {
    //         button.style.height = height + "px";
    //     });
    // }

    startSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, namePlaceholder, imageIncoming, imageOutgoing) {
        if (activeText.length > 25) {
            namePlaceholder.parentElement.classList.add('small');
        }
        else {
            namePlaceholder.parentElement.classList.remove('small');
        }
        namePlaceholder.innerText = activeText;
        nameOut.innerText = activeText;
        namePlaceholder.parentElement.style.width = `${namePlaceholder.offsetWidth}px`;


        imageIncoming.setAttribute('src', activeImage);

        imageIncoming.classList.add('fade-in');
        imageOutgoing.classList.add('fade-out');

        nameIn.classList.add('fade-left');
        nameOut.classList.add('fade-right');
    }
    endSubmenuHoverAnimation(activeText, activeImage, nameIn, nameOut, imageIncoming, imageOutgoing) {
        nameIn.classList.remove('fade-left');
        nameOut.classList.remove('fade-right');
        nameIn.innerText = activeText;
        nameOut.innerText = '';

        imageOutgoing.setAttribute('src', activeImage);
        imageIncoming.classList.remove('fade-in');
        imageOutgoing.classList.remove('fade-out');
    }

    initScrollHandlers() {
        this.lastScroll = window.pageYOffset;
        window.addEventListener('scroll', this.scrollHandler.bind(this));
    }

    updateSubmenuHeight(submenu, height) {
        if(!submenu) {
            each(this.subMenus, (_submenu) => {
                if(this.activeSubmenu === _submenu.dataset.submenu) {
                    submenu = _submenu;
                }
            });
        }
        height = height ? height : submenu.offsetHeight;
        this.subMenuContainer.style.height = `${height}px`;
    }

    scrollHandler() {
        // spinning circle in logo
        const angle = 0.2 * window.pageYOffset;
        this.logoCircle.style.transform = `rotate(${angle}deg)`;

        // active/inactive header states
        if (!mq(this.desktopMediaQuery)) {
            // mobile

            //check to see if mobile menu is open, if so we don't want to apply any active/inactive classes
            if(this.menuContainer.classList.contains(this.menuCtrActiveClass)){
                return;
            }

            if (window.pageYOffset > this.el.offsetHeight) {

                if(this.lastScroll > window.pageYOffset) {
                    //scrolling up
                    this.el.classList.remove('inactive');
                    this.expandAlert();

                }else{
                    //scrolling down
                    this.collapseAlert();
                    this.el.classList.add('inactive');
                }
            }
        }else{
            // desktop
            if (window.pageYOffset > this.desktopHeight) {
                this.el.classList.add('inactive');
                this.collapseAlert();
            }else{
                this.el.classList.remove('inactive');
                this.expandAlert();
            }
        }

        this.lastScroll = window.pageYOffset;
    }

    expandAlert() {
        if (this.$emergencyBanner) {
            const event = new CustomEvent('alert:expand', {});
            this.$emergencyBanner.dispatchEvent(event);
        }
    }

    collapseAlert() {
        if (this.$emergencyBanner) {
            const event = new CustomEvent('alert:collapse', {});
            this.$emergencyBanner.dispatchEvent(event);
        }
    }

    expandSearchMenu() {
        let searchMenu;
        each(this.subMenus, (submenu) => {
            if(submenu.dataset.submenu === 'search') {
                searchMenu = submenu;
            }
        })

        if(searchMenu) {
            searchMenu.classList.add('searching');
            this.updateSubmenuHeight(searchMenu);
        }
    }

    minimizeSearchMenu(height) {
        let searchMenu;

        each(this.subMenus, (submenu) => {
            if(submenu.dataset.submenu === 'search') {
                searchMenu = submenu;
            }
        })

        if(searchMenu) {
            searchMenu.classList.remove('searching');
            this.updateSubmenuHeight(searchMenu, height);
        }
    }
    checkForChatButton() {
        if (this.$chatButton) {
            return true;
        }

        var chatButtonEl = document.querySelector('#divSatisfiChat');

        if (chatButtonEl) {
            this.chatButton = chatButtonEl;
            return true;
        }

        return false;
    }
}